export default __webpack_public_path__ + "static/media/home-banner@2x.62ec6450.jpg";